import { API_URL } from '../config/constants';

export const saveSurveys = async (data) => {
  try {
    const request = new Request(API_URL + "/surveys/saveSurveys", {
      method: 'POST',
      body: JSON.stringify({
        username: data.username,
        passwd: data.passwd,
        surveys: data.surveys ? data.surveys : [],
        satisfactionSurveys: data.satisfactionSurveys ? data.satisfactionSurveys : [],
        terminal_id: data.terminal_id,
        device_id: data.device_id
      }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    const response = await fetch(request);
    if (response.status === 500) throw response;
    if (response.status === 400) throw response;
    if (response.status === 403 || response.status === 401) throw response;
    const json = await response.json();
    return json;
  } catch (err) {
    throw err;
  }
}

export const requestSurveys = async (user, passwd, params) => {
  try {
    let url = API_URL;
    if (params.type === 'survey') url += "/v2/getSurveys";
    if (params.type === 'satisfaction') url += "/v2/getSatisfactionSurveys";
    const request = new Request(url, {
      method: 'POST',
      body: JSON.stringify({
        username: user,
        password: passwd,
        start: params.start,
        limit: params.limit,
        filter: params.filter
      }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    const response = await fetch(request);
    if (response.status === 500) throw response;
    if (response.status === 400) throw response;
    if (response.status === 403 || response.status === 401) throw response;
    const json = await response.json();
    return json;
  } catch (err) {
    throw err;
  }
}

export const requestSurvey = async (user, passwd, params) => {
  try {
    let url = API_URL;
    url += "/v2/findSurvey";
    const request = new Request(url, {
      method: 'POST',
      body: JSON.stringify({
        username: user,
        password: passwd,
        id: params.id,
        type: params.type
      }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    const response = await fetch(request);
    if (response.status === 500) throw response;
    if (response.status === 400) throw response;
    if (response.status === 403 || response.status === 401) throw response;
    const json = await response.json();
    return json;
  } catch (err) {
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/controllers/surveys.js